import styled from 'styled-components';
import { MAIN_BLUE } from '../../styles/Colors';
import { below } from '../../utils/Breakpoints';
export const SignContainer = styled.div`
  height: 55%;
  display: flex;
  width: 250px;
  border-radius: 20px;
  background-color: ${MAIN_BLUE};
  margin: auto;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.45);
  ${below.med`
			display:none
		`}
`;

export const String = styled.div`
  width: 3px;
  height: 120%;
  background-color: ${MAIN_BLUE};
  position: relative;
  transform: ${(props) => props.rotation};
  left: ${(props) => props.position};
  top: -30px;
`;

export const OpenCloseText = styled.span`
  color: white;
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 5px;
`;
